import { render } from "./SignatureUpload.vue?vue&type=template&id=da5fd030"
import script from "./SignatureUpload.vue?vue&type=script&lang=js"
export * from "./SignatureUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__